import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ManufacturerLineCardPage } from '@/areas/parts/ManufacturerManagement/ManufacturerLineCardPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/manufacturers/_sidebar/line-card')({
    staticData: { access: { permissions: ['view:supplier'] }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <ManufacturerLineCardPage />;
}
